var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderControls", {
        attrs: { myWeek: false, namespace: _vm.namespace },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("DeliverableTemplates", {
            attrs: {
              filterQuery: _vm.filterQuery,
              expandAll: _vm.expandAll,
              namespace: _vm.namespace
            },
            on: { collapseToggleUpdated: _vm.collapseToggleUpdate }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }